import DOMPurify from "dompurify";

const convertAsterisksToBold = (str: string): string => {
    const boldRegex = /\*([^*]+)\*/g;
    return str.replace(boldRegex, '<b>$1</b>');
}

const convertLineBreakers = (str: string): string => {
    return str.replace(/\n/g, '<br />');
}

const SafeHtmlRenderer = ({ htmlContent }: { htmlContent: string; }) => {
    const cleanHtml = DOMPurify.sanitize(htmlContent); // Clean the input HTML string
    return <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
};

export const formatTextSigns = (str: string) => {
    const contentWithTags = convertLineBreakers(convertAsterisksToBold(str));

    return <SafeHtmlRenderer htmlContent={contentWithTags} />;
}